import { Card, Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import "../index.css";
import { getVisitorCount } from "../APIs/firebaseDashboardApis";
import { DashboardContext } from "../contexts/DashboardContextProvider";

const VisitorAnalyticsWidget = ({ propertyIds, dateRange, rangeLabel }) => {
  const { setVisitorCountCallback } = useContext(DashboardContext);

  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (propertyIds?.length > 0 && dateRange.length > 0) {
      const fetchVisitorCount = async () => {
        setLoading(true);
        const response = await getVisitorCount({ propertyIds, dateRange })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setLoading(false);
          });
        setVisitorCountCallback(response);
        const tempCount = response?.reduce(
          (prev, curr) => prev + (curr.visitorCount || 0),
          0
        );
        setCount(tempCount);
      };
      fetchVisitorCount();
    }
  }, [propertyIds, dateRange, setVisitorCountCallback]);

  return (
    <Spin spinning={loading}>
      <Card
        className="dashboard_card"
        title={
          <>
            <i className="fa-regular fa-user"></i>
            <span className="card_title">Visitors</span>
          </>
        }
      >
        <div className="card-stats-body">
          <p className="stats-body-number-heading">{rangeLabel}</p>
          <p className="stats-body-number">{count}</p>
        </div>
      </Card>
    </Spin>
  );
};

export default React.memo(VisitorAnalyticsWidget);
